import { Component, inject, signal, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonComponent, EmptyStateComponent, IconComponent, Table2Component } from '@pansa/ui';
import { SortEvent, SortState } from '@app/shared/models/sort.model';
import { AuthorizedPersonDTO } from '../../models/authorized-person.model';

@Component({
  selector: 'rqa-authorized-entity-users',
  templateUrl: './authorized-entity-users.component.html',
  styleUrl: './authorized-entity-users.component.scss',
  imports: [
    CommonModule,
    IconComponent,
    Table2Component,
    ButtonComponent,
    EmptyStateComponent
  ]
})
export class AuthorizedEntityUsersComponent {
  @Input() entityUsers: AuthorizedPersonDTO[] = [];
  @Input() entityId: string = '';
  @Output() deleteUser = new EventEmitter<{ entityId: string, id: string }>();
  private router = inject(Router);

  readonly sort = signal<SortState>({
    key: 'id',
    direction: ''
  });
  trackBy: keyof AuthorizedPersonDTO = 'uuid';

  onEditUser(uuid: string): void {
    this.router.navigate([`/authorized-entity/${this.entityId}/edit-person/${uuid}`]);
  }

  onDeleteUser(user: AuthorizedPersonDTO): void {
    this.deleteUser.emit({ entityId: this.entityId, id: user.uuid })
  }

  onSortChange(user: SortEvent<AuthorizedPersonDTO>): void {
    this.sort.set({
      key: user.key,
      direction: user.direction
    });
  }

  onAddPerson(): void {
    this.router.navigate([`/authorized-entity/${this.entityId}/add-person`]);
  }

  onLinkAccount(uuid: string): void {
    this.router.navigate([`/authorized-entity/${this.entityId}/persons/${uuid}`]);
  }

  onCreateAccount():void{
    
  }

}
